import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=108e2e74&scoped=true&"
import script from "./Protocol.vue?vue&type=script&lang=js&"
export * from "./Protocol.vue?vue&type=script&lang=js&"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=108e2e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e2e74",
  null
  
)

export default component.exports